import React from "react";
import { Helper } from "../../../services/index";
interface item {
    label: string;
    key: string;
}

interface Props {
    title: string;
    viewData: item[];
    data: any;
}

function View(props: Props) {
    const { title, viewData, data } = props;
    return (
        <div className="cmp-view">
            <h5 className="cmp-view__title mb-4">{title}</h5>
            <div className="row">
                {viewData.length > 0
                    ? viewData.map((item, index) => {
                          return (
                              <div key={index} className="col-6">
                                  <div className="row mb-3">
                                      <div className="col-4 font-weight-bold">{item.label}</div>
                                      <div className="col-8 d-flex">
                                          <span className="d-inline-block mr-2">:</span>
                                          {typeof data[item.key] === "object" &&
                                          data[item.key] !== null ? (
                                              <div className="d-flex flex-column align-items-start">
                                                  {data[item.key].map(
                                                      (item: string, index: number) => {
                                                          return (
                                                              <span
                                                                  key={index}
                                                                  className="alert alert--customize border-0 mr-0 px-3"
                                                              >
                                                                  {item}
                                                              </span>
                                                          );
                                                      }
                                                  )}
                                              </div>
                                          ) : item.key === "country" ? (
                                              Helper.GetCountryName(data[item.key])
                                          ) : item.key === "appName" ? (
                                              Helper.GetAppName(data[item.key])
                                          ) : item.key === "createdAt" ? (
                                              Helper.getDate(new Date(data[item.key]))
                                          ) : (
                                              <span className="text-break">{data[item.key]}</span>
                                          )}
                                      </div>
                                  </div>
                              </div>
                          );
                      })
                    : ""}
            </div>
        </div>
    );
}

View.propTypes = {};

export default View;
